import { Point2D } from "datatypes/SoramaLocalApi";

// Get derivative values for an array of 2D points, calculated by central difference approximation
export function derivatives(array: Point2D[]): Point2D[] {
    const derivatives: Point2D[] = [];

    if (array.length > 1) {
        // First item - difference between first and second
        derivatives.push({
            x: array[0].x,
            y: (array[1].y - array[0].y) / (array[1].x - array[0].x),
        });

        // Other items - difference between previous and next
        for (let i = 1; i < array.length - 1; i++) {
            derivatives.push({
                x: array[i].x,
                y: (array[i + 1].y - array[i - 1].y) / (array[i + 1].x - array[i - 1].x),
            });
        }

        // Last item - difference between second-to-last and last
        derivatives.push({
            x: array[array.length - 1].x,
            y:
                (array[array.length - 1].y - array[array.length - 2].y) /
                (array[array.length - 1].x - array[array.length - 2].x),
        });
    }

    return derivatives;
}
